export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";